import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import FooterComponent from "./components/footer.component";
import LogoComponent from "./components/leftpane/items/logo.component";
import TermsConditionsComponent from "./components/other/TermsConditionsComponent";
import AboutPage from "./pages/about.page";
import Careers from "./pages/careers/careers";
import { CareersFoundingEngineer } from "./pages/careers/founding-engineer";
import { CareersSalesSpecialist2 } from "./pages/careers/sales-specialist2";
import ContactUs from "./pages/contact-us.page";
import ForgotPassword from "./pages/forgot-password.page";
import LandingPage from "./pages/landing.page";
import LoginPage2 from "./pages/login2.page";
import ProductsPage from "./pages/products.page";
import RegisterPage3 from "./pages/register3.page";
import AuthProvider from "./providers/auth.provider";
import { AuthenticatedRoutes } from "./routes";
import "./styles/button.styles.css";
import ForgotPassword2 from "./pages/forgot-password2.page";

const Main = () => {
  return (
    <div className={`app`}>
      <BrowserRouter>
        {/*
        Do not move auth provider from here.
        The Mobile header component needs this.
        */}
        <AuthProvider>
          <nav className="top-0 w-full bg-purple backdrop-blur-md border-b border-gray-200 z-50">
            <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <LogoComponent />
              </div>
              <div className="md:flex gap-8 hidden sm:block">
                <a
                  href="https://www.expensehut.com"
                  className="text-white hover:text-white-900"
                >
                  Features
                </a>
                <a
                  href="https://www.expensehut.com/pricing"
                  className="text-white hover:text-white-900"
                >
                  Pricing
                </a>
                <a
                  href="https://www.expensehut.com/login"
                  className="text-white hover:text-white-400"
                >
                  POS Login
                </a>
              </div>
              <Link
                to="/register"
                className="inline-flex items-center justify-center 
                      px-2 py-1
                      rounded-md 
                      font-medium 
                      text-white
                      bg-blue-600 
                      hover:bg-blue-700 
                      active:bg-blue-800 
                      transition-colors duration-200
                      no-underline
                      my-2
                      border-blue-700
                      "
              >
                Get Started
              </Link>
            </div>
          </nav>

          <Routes>
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/about" element={<AboutPage />} />
            <Route
              path="/careers/sales-specialist"
              element={<CareersSalesSpecialist2 />}
            />
            <Route
              path="/careers/founding-engineer"
              element={<CareersFoundingEngineer />}
            />

            <Route
              path="/careers/chief-technology-officer"
              element={<CareersFoundingEngineer />}
            />

            <Route path="/careers" element={<Careers />} />

            <Route path="/forgot-password" element={<ForgotPassword2 />} />
            <Route path="/forgot-password2" element={<ForgotPassword2 />} />

            <Route path="/register" element={<RegisterPage3 />} />
            <Route path="/login" element={<LoginPage2 />} />

            <Route path="/products" element={<ProductsPage />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<AuthenticatedRoutes />} />
          </Routes>
        </AuthProvider>

        <TermsConditionsComponent />
        <FooterComponent />
      </BrowserRouter>
    </div>
  );
};

export default Main;
